import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DefaultButton, Panel, PrimaryButton, SpinButton, Stack, TextField} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";
import NetGrossPicker from "../../Components/NetGrossPicker";

function AddVentureAddon(props) {
    const [user] = useContext(AuthContext);
    const [name, setName] = useState('');
    const [netPrice, setNetPrice] = useState(0);
    const [grossPrice, setGrossPrice] = useState(0);
    const [vat, setVat] = useState(0);
    const [netCost, setNetCost] = useState(0);
    const [grossCost, setGrossCost] = useState(0);

    const _submit = (e) => {
        e.preventDefault();
        const data = {addon: name, net_price: netPrice, vat: vat, gross_price: grossPrice, net_cost: netCost, gross_cost: grossCost, venture_id: props.add.venture_id};
        fetch(`/api/venture/${props.add.venture_id}/addon`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.onSuccess(json); props.dismissPanel(); })
            .catch(err => { console.log(err) })
    }

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='AddVentureAddon'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    useEffect(() => {
        setName('');
        setNetPrice(0);
        setGrossPrice(0);
        setNetCost(0);
        setGrossCost(0);
    }, [props.add])


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Dodaj Dodatek"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='AddVentureAddon'>
                <TextField required autoFocus label='Nazwa' value={name} onChange={(e) => setName(e.target.value || '')}/>
                <NetGrossPicker net={netPrice} setNet={setNetPrice} gross={grossPrice} setGross={setGrossPrice} vat={vat} setVat={setVat}  prefix={'Cena '}/>
                <NetGrossPicker net={netCost} setNet={setNetCost} gross={grossCost} setGross={setGrossCost} vat={vat} setVat={setVat} hideVat={true} prefix={'Koszt '}/>
            </form>
        </Panel>
    )
}

export default AddVentureAddon;